var jobPopup = function(elementID){
  this.elementID = elementID;
  this.popup = document.getElementById(elementID);
  this.load();
};

jobPopup.prototype.load = function(){
  this.events();


};

jobPopup.prototype.setHTML = function(html){
  var el = this.popup.getElementsByClassName("jobPopupScroll");
  if(el && el[0]){
    el[0].innerHTML = html;
  }
};

jobPopup.prototype.events = function(){

  var openLinks = document.querySelectorAll("*[data-popup='"+this.elementID+"']");

  for(let l of openLinks){
    l.addEventListener("click",(e)=>{
      e.preventDefault();
      this.open();
    });
  }

  var closeLink = this.popup.getElementsByClassName("jobPopupClose")[0];
  closeLink.addEventListener("click",(e)=>{
    e.preventDefault();
    this.close();
  });

  this.popup.addEventListener("click",(e)=>{
    if(e.target !== e.currentTarget){
      return;
    }
    this.close();
  });

};

jobPopup.prototype.open = function(){
  this.popup.classList.add("show");
};

jobPopup.prototype.close = function(){
  this.popup.classList.remove("show");
};
